import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactDOM from 'react-dom/client';
import App from './App';
import "./assets/Responsive.css";
import { HelmetProvider } from "react-helmet-async";
import {ToastContainer} from 'react-toastify';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
   <React.StrictMode>
    <HelmetProvider>
      <ToastContainer position="top-center" autoClose={3000}/>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);